<template>
    <div class="base-card__content tabsGenres-content-skeleton"/>
</template>
